import "core-js/modules/es.array.every.js";
import isPropValid from '@emotion/is-prop-valid';
export var exceptStyledProps = function exceptStyledProps() {
  for (var _len = arguments.length, exceptedProps = new Array(_len), _key = 0; _key < _len; _key++) {
    exceptedProps[_key] = arguments[_key];
  }

  return {
    shouldForwardProp: function shouldForwardProp(prop) {
      return isPropValid(prop) && exceptedProps.every(function (exceptedProp) {
        return exceptedProp !== prop;
      });
    }
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9leGNlcHRTdHlsZWRQcm9wcy50cyJdLCJuYW1lcyI6WyJpc1Byb3BWYWxpZCIsImV4Y2VwdFN0eWxlZFByb3BzIiwiZXhjZXB0ZWRQcm9wcyIsInNob3VsZEZvcndhcmRQcm9wIiwicHJvcCIsImV2ZXJ5IiwiZXhjZXB0ZWRQcm9wIl0sIm1hcHBpbmdzIjoiO0FBQUEsT0FBT0EsV0FBUCxNQUF3Qix3QkFBeEI7QUFFQSxPQUFPLElBQU1DLGlCQUFpQixHQUFHLFNBQXBCQSxpQkFBb0I7QUFBQSxvQ0FBSUMsYUFBSjtBQUFJQSxJQUFBQSxhQUFKO0FBQUE7O0FBQUEsU0FBaUM7QUFDaEVDLElBQUFBLGlCQUFpQixFQUFFLDJCQUFDQyxJQUFEO0FBQUEsYUFDakJKLFdBQVcsQ0FBQ0ksSUFBRCxDQUFYLElBQXFCRixhQUFhLENBQUNHLEtBQWQsQ0FBb0IsVUFBQUMsWUFBWTtBQUFBLGVBQUlBLFlBQVksS0FBS0YsSUFBckI7QUFBQSxPQUFoQyxDQURKO0FBQUE7QUFENkMsR0FBakM7QUFBQSxDQUExQiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBpc1Byb3BWYWxpZCBmcm9tICdAZW1vdGlvbi9pcy1wcm9wLXZhbGlkJztcblxuZXhwb3J0IGNvbnN0IGV4Y2VwdFN0eWxlZFByb3BzID0gKC4uLmV4Y2VwdGVkUHJvcHM6IHN0cmluZ1tdKSA9PiAoe1xuICBzaG91bGRGb3J3YXJkUHJvcDogKHByb3A6IHN0cmluZykgPT5cbiAgICBpc1Byb3BWYWxpZChwcm9wKSAmJiBleGNlcHRlZFByb3BzLmV2ZXJ5KGV4Y2VwdGVkUHJvcCA9PiBleGNlcHRlZFByb3AgIT09IHByb3ApXG59KTtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/@utex/ui-kit/dist/utils/exceptStyledProps.js
// module id = 1734
// module chunks = 118